import i18next, { loadLanguage } from '../i18n';
import { languageList } from '../constants/languages';

// Страницы без префикса /:lang/
export const NO_LANG_PATHS = ['/privacy-policy', '/privacy-policy-ios'];

const STORAGE_KEY = 'i18nextLng';
const symbols = languageList.map(language => language.symbol);

// 'pt_BR' -> 'pt-br', 'sr_Latn' -> 'sr-latn'
export const toUrlCode = symbol => symbol.toLowerCase().replace('_', '-');

// 'pt-br' / 'pt_BR' / 'PT-BR' -> 'pt_BR'; null, если язык не поддерживается
export const fromCode = code => {
  if (!code) {
    return null;
  }
  const normalized = code.toLowerCase().replace('_', '-');
  return symbols.find(symbol => toUrlCode(symbol) === normalized) ?? null;
};

// Сопоставляет локаль браузера (navigator.languages) с поддерживаемым языком
const matchBrowserLocale = locale => {
  const exact = fromCode(locale);
  if (exact) {
    return exact;
  }
  const [base, ...rest] = locale.toLowerCase().replace('_', '-').split('-');
  const region = rest.join('-');
  switch (base) {
    case 'pt':
      return region === 'br' ? 'pt_BR' : 'pt_PT';
    case 'zh':
      return ['hant', 'tw', 'hk', 'mo'].some(part => region.includes(part)) ? 'zh_TW' : 'zh_CN';
    case 'sr':
      return region.includes('latn') ? 'sr_Latn' : 'sr';
    case 'in':
      return 'id';
    case 'tl':
      return 'fil';
    case 'no':
    case 'nn':
      return 'nb';
    default:
      return fromCode(base);
  }
};

const readStoredLanguage = () => {
  try {
    return fromCode(localStorage.getItem(STORAGE_KEY));
  } catch (e) {
    return null;
  }
};

const storeLanguage = symbol => {
  try {
    localStorage.setItem(STORAGE_KEY, symbol);
  } catch (e) {
    // localStorage недоступен (приватный режим) — язык всё равно хранится в URL
  }
};

// Сохранённый выбор, затем языки браузера, затем английский
export const detectLanguage = () => {
  const stored = readStoredLanguage();
  if (stored) {
    return stored;
  }
  const locales = navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const locale of locales) {
    const match = locale && matchBrowserLocale(locale);
    if (match) {
      return match;
    }
  }
  return 'en';
};

// '/ru/element/1' -> { lang: 'ru', rest: '/element/1' }; lang = null, если префикса нет
export const parsePath = pathname => {
  const [, first = '', ...others] = pathname.split('/');
  const lang = fromCode(first);
  if (!lang) {
    return { lang: null, rest: pathname };
  }
  return { lang, rest: `/${others.join('/')}` };
};

export const buildPath = (symbol, rest) => `/${toUrlCode(symbol)}${rest === '/' ? '/' : rest}`;

export const applyLanguage = async symbol => {
  await loadLanguage(symbol);
  await i18next.changeLanguage(symbol);
  storeLanguage(symbol);
};

export const SITE_URL = 'https://periodic-table.tech';

// Код для <html lang> и hreflang: 'pt_BR' -> 'pt-BR', 'sr_Latn' -> 'sr-Latn'
export const toLangTag = symbol => symbol.replace('_', '-');

// Полный адрес страницы на нужном языке: ('ru', '/element/7') -> 'https://periodic-table.tech/ru/element/7'
export const buildUrl = (symbol, rest) => `${SITE_URL}${buildPath(symbol, rest)}`;
